/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "any",
    title: "Any",
    alias: "*",
    description: "A field that accepts anything, useful for wildcard matching or when the type is not known.",
    type: "field",
    use: {
        namespace: "ua.input"
    }
});

function validate(spec, value) {
   return;
}
module.exports.validate = validate;
